import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {VisitContext} from "../../../../visit-context";
import {
  LocalMovement,
  OrderablePilotTransferPoint,
  PilotTransferPoint
} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {removeItem} from "../../../../../common/utils";

@Component({
  selector: 'app-pilot-trajectory',
  templateUrl: './pilot-trajectory.component.html',
  styleUrls: ['./pilot-trajectory.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PilotTrajectoryComponent implements OnInit {
  @Input() localMovement: LocalMovement;

  refData = PortvisitUtils;
  context = VisitContext;

  ngOnInit() {
    if (!!this.possibleTransferPoints?.length) {
      this.localMovement.trajectory = this.localMovement.trajectory || [];
    }
  }

  get possibleTransferPoints() {
    return this.context.visit.portOfCall.pilotTransferPoints;
  }

  get trajectory() {
    return this.localMovement.trajectory;
  }

  set trajectory(possibleTransferPoints) {
    this.localMovement.trajectory = possibleTransferPoints;
  }

  addNewPilotTransferPoint = (transferPoint: PilotTransferPoint) =>
    this.trajectory = this.trajectory.concat(transferPoint);

  deletePilotTransferPoint = (transferPoint: OrderablePilotTransferPoint) =>
    this.trajectory = removeItem(this.trajectory, transferPoint);

  get filteredPossibleTransferPoints() {
    const lastTransferPoint = this.trajectory?.length ? this.trajectory[this.trajectory.length - 1] : null;
    if (lastTransferPoint) {
      return lastTransferPoint.nextTransferPoints?.length
        ? this.possibleTransferPoints.filter(p => lastTransferPoint.nextTransferPoints.includes(p.pilotTransferPointId))
          .filter(p => !this.trajectory.map(p => p.pilotTransferPointId)
            .includes(p.pilotTransferPointId))
        : this.possibleTransferPoints.filter(p => !this.trajectory.map(p => p.pilotTransferPointId)
          .includes(p.pilotTransferPointId));
    }
    return this.possibleTransferPoints;
  }
}
